import { defineStore } from 'pinia';
import axios from 'axios';
import { Auth } from 'aws-amplify';

export const onboardingStore = defineStore('onboarding', {
  state: () => ({
    formData: {
      user: null, // Placeholder for AWS Cognito user ID
      cat_whisperer: '',
      onboarding_goals: [], // Initialize as an array
      cashflow_goals: '',
      car: '',
      credit: '',
      investment: [], // Initialize as an array
      insurance: [], // Initialize as an array
      marital_status: '',
      dependents: '',
      num_dependents: null,
      risk_relationship: '',
      housing_status: '',
      employment_status: [], // Initialize as an array
      financial_situation: '',
      area: '',
      own_pets: '',
      privacy: false,
      date_of_birth: null,
      country_of_residence: '', 
    },
  }),
  actions: {
    updateFormData(newFormData) {
      // Update the form data with the new values
      this.formData = { ...this.formData, ...newFormData };
    },
    async submitFormData() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        
        // Prepare your payload here, converting arrays to comma-separated strings
        const payload = {
          ...this.formData,
          user: cognitoSub,
          onboarding_goals: this.formData.onboarding_goals.join(','),
          investment: this.formData.investment.join(','),
          insurance: this.formData.insurance.join(','),
          employment_status: this.formData.employment_status.join(','),
        };

        // Adjust the endpoint as necessary
        const response = await axios.post('https://api.riskypaws.com/frontoffice/api/client-info/', payload, {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });

        console.log('Form data submitted successfully:', response.data);
        // Handle success (e.g., clear form, show success message)
      } catch (error) {
        console.error('Error submitting form data:', error);
        // Handle error (e.g., show error message)
      }
    },
  },
});